import React from 'react';

export default function UnderConstruction() {
  return (
    <div className="min-h-[60vh] flex items-center justify-center bg-white">
      <div className="text-center max-w-md p-8">
        <div className="mx-auto mb-4 w-14 h-14 rounded-full border-4 border-dashed border-gray-300 animate-spin" />
        <h1 className="text-2xl font-semibold text-gray-900 mb-2">Under construction</h1>
        <p className="text-gray-600 text-sm">We are working hard on this page. Please check back soon.</p>
      </div>
    </div>
  );
}


